import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import queryok from '@/components/queryok'
import SecondPage from '@/components/SecondPage'
import heard from '@/components/public/heard.vue'
import Userheard from '@/components/public/Userheard.vue'
import body from '@/components/public/body.vue'
import Map from '@/components/public/map.vue'
import Draw_Map from '@/components/draw_map/draw_map.vue'
import login from '@/components/log/login.vue'
import register from '@/components/log/register.vue'
import success from '@/components/log/success.vue'
import loginok from '@/components/log/loginok.vue'
import ordermanage from '@/components/user/ordermanage.vue'
import ladingmessage from '@/components/user/ladingmessage.vue'
import companyinfor from '@/components/user/companyinfor.vue'

Vue.use(Router)
export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/queryok',
    name: 'queryok',
    component: queryok
  },
  {
    path: '/SecondPage',
    name: 'SecondPage',
    component: SecondPage
  },
  {
    path: '/public/heard',
    name: 'heard',
    component: SecondPage
  },
  {
    path: '/public/Userheard',
    name: 'Userheard',
    component: Userheard
  },
  {
    path: '/public/body',
    name: 'body',
    component: body
  },

  {
    path: '/public/map',
    name: 'Map',
    component: Map
  },
  {
    path: '/draw_map/draw_map',
    name: 'Draw_Map',
    component: Draw_Map
  },

  {
    path: '/log/login',
    name: 'login',
    component: login
  },
  {
    path: '/log/register',
    name: 'register',
    component: register
  },
  {
    path: '/log/success',
    name: 'success',
    component: success
  },

  {
    path: '/log/loginok',
    name: 'loginok',
    component: loginok
  },
  {
    path: '/user/ladingmessage',
    name: 'ladingmessage',
    component: ladingmessage
  },
  {
    path: '/user/companyinfor',
    name: 'companyinfor',
    component: companyinfor
  },

  {
    path: '/user/ordermanage',
    name: 'ordermanage',
    component: ordermanage
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js